import {
  UPDATE_PASSWORD_BEGIN,
  UPDATE_PASSWORD_SUCCESS,
  UPDATE_PASSWORD_ERROR,
} from './constants';

export const updatePasswordBegin = () => ({
  type: UPDATE_PASSWORD_BEGIN,
});

export const updatePasswordSuccess = payload => ({
  type: UPDATE_PASSWORD_SUCCESS,
  payload,
});

export const updatePasswordError = payload => ({
  type: UPDATE_PASSWORD_ERROR,
  payload,
});
